module.exports = """
  fragment popular_artists_context on HomePageModuleContextTrending {
    artists {
      name
      id
    }
  }
"""
